export default function Dataschutzcontent() {
  const lastUpdated = "Mai 2026";
  const disclosureSections = [{
    title: "1. DATENSCHUTZ AUF EINEN BLICK",
    content: `Allgemeine Hinweise
Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie unsere Websites besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.

Geltungsbereich
Diese Datenschutzerklärung gilt für alle Webseiten und Online-Präsenzen des Resilienzzentrums Soonwald:
www.resilienz-zentrum-soonwald.de
www.praxis-soonwald.de
www.christ-coaching.de
www.tai-chi-soonwald.de
www.wildnisschule-soonwald.de

Verantwortliche Stelle
Die Datenverarbeitung auf diesen Websites erfolgt durch die Betreiberin:
Claudia Christ
Diplom-Psychologin
Im Rödchen 3
D-55595 Spabrücken
E-Mail: post@claudiachrist.de`
  }, {
    title: "2. BESONDERER SCHUTZBEREICH: PSYCHOLOGISCHE PRAXIS & KRISENBERATUNG",
    content: `Wichtiger Schutzhinweis: Alle Daten, die im Rahmen der psychologischen Praxis und Krisenberatung erhoben werden, unterliegen der strengsten Vertraulichkeit. Sie sind physisch und digital vollkommen von den Datenverarbeitungen der anderen Campus-Bereiche (Kurse, Messenger, Marketing) getrennt.

Gesetzliche Schweigepflicht
Alle im Rahmen der Beratung oder Therapie anvertrauten Informationen unterliegen der gesetzlichen Schweigepflicht gemäß § 203 StGB. Eine Weitergabe an Dritte erfolgt ausschließlich bei Vorliegen einer expliziten, schriftlichen Entbindung von der Schweigepflicht durch den Klienten/Patienten.

Aufbewahrungspflichten nach dem Patientenrechtegesetz
Patienten- und Behandlungsakten werden gemäß den gesetzlichen Vorgaben des § 630f BGB für einen Zeitraum von mindestens 10 Jahren nach Abschluss der Behandlung in einem geschützten, zugriffsbeschränkten System sicher verwahrt und anschließend datenschutzkonform vernichtet.`
  }, {
    title: "3. HOSTING UND IT-INFRASTRUKTUR",
    content: `Für den stabilen, schnellen und sicheren Betrieb aller oben genannten Websites nutzen wir eine aufeinander abgestimmte Cloud-Infrastruktur. Die Datenübertragung erfolgt auf allen Seiten verschlüsselt (SSL/TLS).

10Web und Google Cloud Platform
Wir hosten unsere Websites über die Plattform 10Web (Anbieter: 10Web Inc., 40 E Main St, Suite 721, Newark, DE 19711, USA). Die tatsächliche Speicherung und Verarbeitung der Daten erfolgt auf zertifizierten Servern der Google Cloud Platform im Rechenzentrum Frankfurt am Main (Deutschland).

Amazon S3 (Medien-Hosting)
Bilder, Grafiken und Dokumente werden auf Servern von Amazon Web Services gespeichert (Anbieter: Amazon Web Services EMEA SARL, 38 Avenue John F. Kennedy, L-1855 Luxemburg). Dies dient unserem berechtigten Interesse (Art. 6 Abs. 1 lit. f DSGVO), die Ladezeiten, Stabilität und Sicherheit unserer Online-Präsenzen zu optimieren.

Cloudflare (Sicherheitsfilter)
Zur Abwehr von Cyberangriffen (z. B. DDoS-Attacken) und zur Performance-Optimierung nutzen wir die Dienste der Cloudflare Inc. (USA). Cloudflare fungiert als Sicherheitsfilter (Web Application Firewall) zwischen unseren Servern und Ihrem Browser.

Hinweis zum internationalen Datentransfer: Alle eingesetzten US-Dienstleister sind nach dem EU-US Data Privacy Framework certified, wodurch ein den EU-Standards entsprechendes Datenschutzniveau gewährleistet ist.`
  }, {
    title: "4. DATENERFASSUNG AUF UNSEREN WEBSITES",
    content: `Datensparsamkeit & Cookies
Wir verfolgen das Prinzip der maximalen Datensparsamkeit. Wir verzichten auf allen unseren Websites bewusst auf Analyse-Tools (wie Google Analytics) und Tracking-Cookies. Da keine technisch nicht-notwendigen Cookies gesetzt werden, ist ein Cookie-Banner auf unseren Websites rechtlich nicht erforderlich.

Server-Log-Dateien
Der Provider der Seiten erhebt und speichert automatisch Informationen in sogenannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:
- Browsertyp und Browserversion
- Verwendetes Betriebssystem
- Referrer URL (die zuvor besuchte Seite)
- Hostname des zugreifenden Rechners (IP-Adresse)
- Uhrzeit der Serveranfrage

Diese Daten sind nicht bestimmten Personen zuordenbar. Die Verarbeitung erfolgt auf Basis von Art. 6 Abs. 1 lit. f DSGVO zur Gewährleistung der Systemsicherheit und des störungsfreien Betriebs.

Kontaktaufnahme per E-Mail
Wenn Sie uns per E-Mail kontaktieren, werden Ihre Angaben (Name, E-Mail-Adresse, Nachrichtentext) zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO zur Durchführung vorvertraglicher Maßnahmen oder zur Vertragserfüllung.`
  }, {
    title: "5. OPTIONALE DATENVERARBEITUNG (NUR FÜR KURSE, SEMINARE & WILDNISSCHULE)",
    content: `Kommunikation via WhatsApp und Messenger
Sofern Sie uns Ihre Mobilfunknummer mitteilen oder uns aktiv über WhatsApp oder vergleichbare Messenger-Dienste kontaktieren, nutzen wir diese Kanäle ausschließlich zur Organisation von Kursen, für kurzfristige Terminabsprachen oder zur Übermittlung dringender Kursinfos (z. B. wetterbedingte Verlegungen in den Wald).

Rechtsgrundlage: Die Nutzung erfolgt basierend auf Ihrer freiwilligen Einwilligung (Art. 6 Abs. 1 lit. a DSGVO) oder zur Vertragserfüllung (Art. 6 Abs. 1 lit. b DSGVO).

Widerruf: Sie können Ihre Einwilligung zur Messenger-Kommunikation jederzeit mit Wirkung für die Zukunft per E-Mail oder direkt im Messenger widerrufen.

Sicherheitshinweis: Messenger-Dienste wie WhatsApp (Meta Platforms, USA) verarbeiten Daten außerhalb der EU. Nutzen Sie diesen Kanal daher bitte nur für organisatorische Absprachen und senden Sie uns darüber keine sensiblen gesundheitlichen oder therapeutischen Informationen.

Foto- und Videoaufnahmen bei Veranstaltungen
Im Rahmen unserer offenen Kurse, Seminare und Workshops (z. B. in der Tai Chi Schule oder Wildnisschule) werden gelegentlich Foto- und Videoaufnahmen angefertigt. Diese dienen der Dokumentation und der bildlichen Außendarstellung unserer Arbeit (z. B. auf der Website oder in Informationsmaterialien).

Rechtsgrundlage: Die Verarbeitung basiert auf unserem berechtigten Interesse an zeitgemäßer Öffentlichkeitsarbeit (Art. 6 Abs. 1 lit. f DSGVO).

Widerspruchsrecht: Sie haben jederzeit das Recht, den Aufnahmen oder einer Veröffentlichung zu widersprechen. Bitte teilen Sie uns dies formlos vor Beginn einer Veranstaltung vor Ort oder vorab per E-Mail mit. Wir respektieren Ihre Privatsphäre vollumfänglich und fertigen in diesem Fall keine Aufnahmen von Ihnen an.`
  }, {
    title: "6. IHRE GESETZLICHEN RECHTE",
    content: `Sie haben als von der Datenverarbeitung betroffene Person jederzeit das Recht auf:
- Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten (Art. 15 DSGVO).
- Berichtigung unrichtiger Daten (Art. 16 DSGVO).
- Löschung Ihrer bei uns gespeicherten Daten, sofern keine gesetzlichen Aufbewahrungspflichten entgegenstehen (Art. 17 DSGVO).
- Einschränkung der Verarbeitung (Art. 18 DSGVO).
- Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft (Art. 7 Abs. 3 DSGVO).

Beschwerderecht bei der Aufsichtsbehörde
Wenn Sie glauben, dass die Verarbeitung Ihrer Daten gegen das Datenschutzrecht verstoßt, haben Sie das Recht auf Beschwerde bei der zuständigen Aufsichtsbehörde:
Der Landesbeauftragte für den Datenschutz und die Informationsfreiheit Rheinland-Pfalz (LfDI RLP)
Hintere Bleiche 34
55116 Mainz`
  }];
  return <section data-section-id="261179" id="dataschutzcontent" className="bg-background py-16 md:py-24 lg:py-32 text-foreground">
      <div className="container mx-auto px-4 md:px-6 max-w-[800px]">
        <div className="mb-12 md:mb-16">
          <h1 className="text-4xl md:text-5xl font-bold font-serif tracking-tight mb-4 text-primary">
            Datenschutz<span className="text-foreground">erklärung</span>
          </h1>
          <p className="text-muted-foreground text-sm md:text-base font-default">
            Stand: {lastUpdated}
          </p>
        </div>

        <div className="space-y-10 md:space-y-12">
          {disclosureSections.map((section, index) => <div key={index} data-index={index} className="space-y-3">
              <h2 className="text-xl md:text-2xl font-semibold font-serif text-primary border-t-2 border-primary pt-4">
                {section.title}
              </h2>
              <p className="text-foreground leading-[1.7] text-base md:text-[18px] font-default whitespace-pre-line">
                {section.content}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}